import { useCallback, useEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

const useResize = function() {
  const [showNumber, setShowNumber] = useState(8);

  const handelResize = useCallback((entries, observer) => {
    for (const entry of entries) {
      const {
        // left, top,
        width,
        //  height
      } = entry.contentRect;
      if (width < 1330) {
        setShowNumber(8);
      } else if (width >= 1330 && width < 1465) {
        setShowNumber(10);
      } else if (width >= 1465 && width < 1600) {
        setShowNumber(11);
      } else if (width >= 1600 && width < 1870) {
        setShowNumber(13);
      } else if (width >= 1870) {
        setShowNumber(16);
      }
    }
  }, []);
  const getClassType = useCallback(
    (index = 0) => {
      const series = {
        '8': {
          small: [1, 6],
          small_space: [2, 3, 7, 0],
          big: [4],
          big_space: [5],
        },
        '10': {
          small: [1, 7],
          small_space: [2, 3, 4, 8, 9, 0],
          big: [5],
          big_space: [6],
        },
        '11': {
          small: [1, 8],
          small_space: [2, 3, 4, 9, 10, 0],
          big: [5],
          big_space: [6, 7],
        },
        '13': {
          small: [1, 9],
          small_space: [2, 3, 4, 5, 10, 11, 12, 0],
          big: [6],
          big_space: [7, 8],
        },
        '16': {
          small: [1, 11],
          small_space: [2, 3, 4, 5, 6, 12, 13, 14, 15, 0],
          big: [7],
          big_space: [8, 9, 10],
        },
      };
      const pos = (index + 1) % parseInt(showNumber);
      let classType = 'small';
      if (series[showNumber].small.indexOf(pos) > -1) {
        classType = 'small';
      }
      if (series[showNumber].small_space.indexOf(pos) > -1) {
        classType = 'small_space';
      }
      if (series[showNumber].big.indexOf(pos) > -1) {
        classType = 'big';
      }
      if (series[showNumber].big_space.indexOf(pos) > -1) {
        classType = 'big_space';
      }
      return classType;
    },
    [showNumber],
  );

  useEffect(() => {
    const ro = new ResizeObserver(handelResize);
    ro.observe(document.body);
  }, []);

  return {
    showNumber,
    getClassType: getClassType,
  };
};
export default useResize;
